import { useState, useEffect, useCallback } from 'react';
import useUnauthorize from './useUnauthorize';
import { useToken } from '../common/helper';
import { GetLocations } from '@/apis/onboarding';
import { LocationData } from '@/apis/types';

interface UseFetchLocationsReturn {
  locations: LocationData[];
  loading: boolean;
  refetchLocations: () => void;
}

const useFetchLocations = (): UseFetchLocationsReturn => {
  const { checkTokenExpiry } = useToken();
  const { unauthorize } = useUnauthorize();
  const [locations, setLocations] = useState<LocationData[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchLocations = useCallback(() => {
    setLoading(true);
    const token = checkTokenExpiry();
    if (!token) {
      setLoading(false);
      return;
    }
    // Use pagination to avoid loading all locations at once
    GetLocations(token, false, false, 1)
      .then((res) => {
        const responseData = res?.data;
        if (
          responseData?.data?.is_success &&
          Array.isArray(responseData?.data?.data?.data)
        ) {
          setLocations(responseData.data.data.data);
        } else {
          setLocations([]);
        }
      })
      .catch((err) => {
        unauthorize(err);
        setLocations([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [checkTokenExpiry, unauthorize]);

  useEffect(() => {
    fetchLocations();
  }, [fetchLocations]);

  return { locations, loading, refetchLocations: fetchLocations };
};

export default useFetchLocations;
